export const MT_CONTEXTS = {
    GENERAL: 'general',
    SEARCH: 'search',
    GIG_TITLE: 'gig_title',
};
